import { BcmTenantType } from '@modules/bcm/@shared/enums/bcm-tenant-type';
import { TenantRegisterType } from '@modules/bcm/@shared/enums/tenant-register-type';

/** True when the tenant is configured as a Verein in Hafeneinstellungen. */
export function isSocietyTenant(registerType: TenantRegisterType): boolean {
    return registerType === TenantRegisterType.Society;
}

/** Inland-port tenants keep the dedicated Kundenbeziehung overrides via Tolgee namespace. */
export function usesSocietyRelationLabels(
    registerType: TenantRegisterType,
    productType: BcmTenantType,
): boolean {
    return productType === BcmTenantType.InlandPort || isSocietyTenant(registerType);
}

export function bookingV2RelationLabelKey(
    suffix: string,
    registerType: TenantRegisterType,
    productType: BcmTenantType,
): string {
    const prefix = usesSocietyRelationLabels(registerType, productType)
        ? 'bookingV2.person.relation'
        : 'bookingV2.person.relation.commercial';
    return `${prefix}.${suffix}`;
}

export function bookingV2SummaryRelationsLabelKey(
    registerType: TenantRegisterType,
    productType: BcmTenantType,
): string {
    return usesSocietyRelationLabels(registerType, productType)
        ? 'bookingV2.summary.relations'
        : 'bookingV2.summary.relationsCommercial';
}

export function bookingV2RechnungsversandRelationLabelKey(
    registerType: TenantRegisterType,
    productType: BcmTenantType,
): string {
    return usesSocietyRelationLabels(registerType, productType)
        ? 'bookingV2.rechnungsversand.source.relation'
        : 'bookingV2.rechnungsversand.source.relationCommercial';
}

export function bookingV2RelationProductsEmptyLabelKey(
    registerType: TenantRegisterType,
    productType: BcmTenantType,
): string {
    return usesSocietyRelationLabels(registerType, productType)
        ? 'bookingV2.person.relationProducts.empty'
        : 'bookingV2.person.relationProducts.emptyCommercial';
}
